import { PasswordTooltipContent, Tooltip } from "..";
import { ReactComponent as QuestionIcon } from "assets/question.svg";
import "./index.scss";

export const PasswordTooltipHint = () => {
  return (
    <div className="password-tooltip-hint-container">
      <Tooltip
        position="right"
        content={<PasswordTooltipContent />}
        customClassName="password-tooltip"
      >
        <QuestionIcon />
      </Tooltip>
    </div>
  );
};
